import { USER_FIELDS } from "../fields";
import { IRole } from "../../../role.entity/redux/type";
import COMMON_FIELDS from "../../../../../../general/constants/commonFields";

export interface IProfile {
	[USER_FIELDS.AVATAR]: string | null;
	[USER_FIELDS.DESKTOP]: number | null;
	[USER_FIELDS.NAME]: string | null;
	[USER_FIELDS.LAST_NAME]: string | null;

	// 	dto
}

export interface IUser {
	[USER_FIELDS.ID]: number | null;
	[USER_FIELDS.USER_ID]: number | null;
	[USER_FIELDS.NAME]: string | null;
	[USER_FIELDS.LAST_NAME]: string | null;
	[USER_FIELDS.MIDDLE_NAME]: string | null;
	[USER_FIELDS.STATUS]: StatusUser;
	[USER_FIELDS.MANAGER]: IUser | null;
	[USER_FIELDS.MANAGER_ID]: string | null;
	[USER_FIELDS.CREATED_AT]: string | null;
	[USER_FIELDS.POSITION]: string | null;
	[USER_FIELDS.EMAIL]: string | null;
	[USER_FIELDS.ROLE]: IRole | null;
	[USER_FIELDS.REASON]: string | null;
	[USER_FIELDS.LOGIN]: string | null;
	[USER_FIELDS.IMAGE]: string | null;

	// 	dto
	[USER_FIELDS.FULL_NAME]: string | null;
	[USER_FIELDS.CREATED_AT_FORMATTED]: string | null;
	// [MEETING_FIELDS.DATE_START_FORMAT]?: string | null;
	// [MEETING_FIELDS.DATE_FORMAT]?: string | null;
	// [MEETING_FIELDS.TIME_FORMAT]?: string | null;
}

export interface IUsersCount {
	[USER_FIELDS.LENGTH]: number | null;

	// 	dto
	// [MEETING_FIELDS.DATE_START_FORMAT]?: string | null;
	// [MEETING_FIELDS.DATE_FORMAT]?: string | null;
	// [MEETING_FIELDS.TIME_FORMAT]?: string | null;
}

export interface IUsersFilter {
	[USER_FIELDS.TEXT]?: string;
	[USER_FIELDS.DIVISION_ID]?: number;
	[USER_FIELDS.MANAGER_ID]?: number;
	[USER_FIELDS.STATUS]?: StatusUser;
	[USER_FIELDS.PAGE_N]?: number;
	[USER_FIELDS.PAGE_SIZE]?: number;
	[COMMON_FIELDS.SORT_BY]?: {
		[COMMON_FIELDS.ID]: string;
		[COMMON_FIELDS.TYPE]: ORDER;
	}[];

	// 	dto
	// [MEETING_FIELDS.DATE_START_FORMAT]?: string | null;
	// [MEETING_FIELDS.DATE_FORMAT]?: string | null;
	// [MEETING_FIELDS.TIME_FORMAT]?: string | null;
}

export interface IRequestsPasswordUserFilter {
	[USER_FIELDS.TEXT]?: string;
	[USER_FIELDS.DIVISION_ID]?: number;
	[USER_FIELDS.MANAGER_ID]?: number;
	[USER_FIELDS.IS_DONE]?: boolean;
	[USER_FIELDS.PAGE_N]?: number;
	[USER_FIELDS.PAGE_SIZE]?: number;
	[COMMON_FIELDS.SORT_BY]?: {
		[COMMON_FIELDS.ID]: string;
		[COMMON_FIELDS.TYPE]: ORDER;
	}[];
	// 	dto
	// [MEETING_FIELDS.DATE_START_FORMAT]?: string | null;
	// [MEETING_FIELDS.DATE_FORMAT]?: string | null;
	// [MEETING_FIELDS.TIME_FORMAT]?: string | null;
}

export interface IUsersRequestPassword {
	[USER_FIELDS.ID]?: number;
	[USER_FIELDS.CREATOR_USER_ID]?: string;
	[USER_FIELDS.CREATED_AT]?: number;
	[USER_FIELDS.USER]?: IUser;
	[USER_FIELDS.IS_DONE]?: boolean;
	// [USER_FIELDS.STATUS]?: StatusRequestPasswordUser;
	// 	dto
	[USER_FIELDS.CREATED_AT_FORMATTED]?: string;
	// [MEETING_FIELDS.DATE_START_FORMAT]?: string | null;
	// [MEETING_FIELDS.DATE_FORMAT]?: string | null;
	// [MEETING_FIELDS.TIME_FORMAT]?: string | null;
}

export enum STATUS_USER {
	DRAFT = "DRAFT",
	REQUEST = "REQUEST",
	ACTIVE = "ACTIVE",
	BLOCKED = "BLOCKED",
	UNKNOWN = "UNKNOWN",
}

export enum ORDER {
	ASC = "asc",
	DESC = "desc",
}

export type StatusUser =
	| STATUS_USER.DRAFT
	| STATUS_USER.REQUEST
	| STATUS_USER.ACTIVE
	| STATUS_USER.BLOCKED
	| STATUS_USER.UNKNOWN;
